<template>
  <div id="app">
    <!-- Vue Router will render the matched component here -->
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App',
  };
</script>

<style>
  /* Global styles for sticky header support */
  html {
    scroll-padding-top: 80px; /* Adjust for sticky header height */
  }

  /* Ensure sticky header works on mobile Safari */
  @supports (-webkit-backdrop-filter: blur(10px)) {
    .backdrop-blur-sm {
      -webkit-backdrop-filter: blur(4px);
    }
  }
</style>
